import React from 'react'

import phenom_icon_1 from '../../../../assets/case_study/phenom_icon1_section4.svg'
import phenom_icon_2 from '../../../../assets/case_study/phenom_icon2_section4.svg'
import phenom_icon_3 from '../../../../assets/case_study/phenom_icon3_section4.svg'
import phenom_icon_4 from '../../../../assets/case_study/phenom_icon4_section4.svg'
import phenom_icon_5 from '../../../../assets/case_study/phenom_icon5_section4.svg'

import goken_icon1 from '../../../../assets/case_study/goken_icon1_section4.svg'
import goken_icon2 from '../../../../assets/case_study/goken_icon2_section4.svg'
import goken_icon3 from '../../../../assets/case_study/goken_icon3_section4.svg'
import goken_icon4 from '../../../../assets/case_study/goken_icon4_section4.svg'
import goken_icon5 from '../../../../assets/case_study/goken_icon5_section4.svg'
import goken_icon6 from '../../../../assets/case_study/goken_icon6_section4.svg'


import ikf_icon1 from '../../../../assets/case_study/ikf_icon1_section4.svg'
import ikf_icon2 from '../../../../assets/case_study/ikf_icon2_section4.svg'
import ikf_icon3 from '../../../../assets/case_study/ikf_icon3_section4.svg'
import ikf_icon4 from '../../../../assets/case_study/ikf_icon4_section4.svg'
import ikf_icon5 from '../../../../assets/case_study/ikf_icon5_section4.svg'

import monitra_icon2 from '../../../../assets/case_study/monitra_icon2_section4.svg'
import monitra_icon3 from '../../../../assets/case_study/monitra_icon3_section4.svg'
import monitra_icon4 from '../../../../assets/case_study/monitra_icon4_section4.svg'
import monitra_icon5 from '../../../../assets/case_study/monitra_icon5_section4.svg'


import incuspaze_icon2 from '../../../../assets/case_study/incuspaze_icon2_section4.svg'
import incuspaze_icon3 from '../../../../assets/case_study/incuspaze_icon3_section4.svg'
import incuspaze_icon4 from '../../../../assets/case_study/incuspaze_icon4_section4.svg'
import incuspaze_icon5 from '../../../../assets/case_study/incuspaze_icon5_section4.svg'
import { useParams } from 'react-router-dom'


const CaseStudySection4 = {
    phenom: {
        top_para: "Hirestar.io partnered with Phenom to deliver a tailored, technology-first BGV solution designed for scale and transparency",
        content1_heading: "Fully Automated Self-Verification Portal:",
        content1_para: "Empowered candidates to complete verification independently, with minimal HR intervention",
        content2_heading: "Integrated Solution with HR Portal:",
        content2_para: "Hirestar directly integrates with Phenom’s HR portal via the APIs, eliminating silos and manual processes. ",
        content3_heading: "AI + Blockchain Engine:",
        content3_para: "Advanced AI flagged document anomalies in real-time, while blockchain ensured tamper-proof audit trails.",
        content4_heading: "Custom Reporting Dashboards:",
        content4_para: "Delivered clear, structured, and real-time BGV reports that were easy to consume and audit.",
        content5_heading: "Customer Success Management: ",
        content5_para: " Hirestar  provided dedicated Customer Success Managemer with SLA-driven responsiveness — reducing query resolution times from days to just hours.",
        content1_image: phenom_icon_1,
        content2_image: phenom_icon_2,
        content3_image: phenom_icon_3,
        content4_image: phenom_icon_4,
        content5_image: phenom_icon_5,
    },
    goken: {
        top_para: "Hirestar.io collaborated closely with Goken’s HR and compliance teams to implement a unified, multilingual, automation-first BGV solution tailored to their diverse workforce and operational needs.",
        content1_heading: "Accelerated TAT:",
        content1_para: "Reduced background verification timelines by over 65% using smart workflow automation and real-time processing.",
        content2_heading: "Multilingual, User-Friendly Verification:",
        content2_para: "Created a mobile-first, regionally localized portal for all candidates — ensuring both white- and blue-collar users could easily complete verifications. ",
        content3_heading: "Unified Platform:",
        content3_para: "Integrated a single dashboard for both white- and blue-collar candidate management — simplifying operations for HR teams.",
        content4_heading: "Customizable Reports:",
        content4_para: "Delivered structured, role-specific reports that aligned with internal audit and compliance needs, including medical check support.",
        content5_heading: "AI-Driven Visitor & Candidate Verification: ",
        content5_para: "Enabled instant face-ID matching, auto-flagging of discrepancies, and real-time visitor check-ins without relying on third-party software.",
        content6_heading: "Blockchain-Secured Reports: ",
        content6_para: "All reports were tamper-proof, timestamped, and audit-ready, reinforcing Goken’s compliance standards.",
        content1_image: goken_icon1,
        content2_image: goken_icon2,
        content3_image: goken_icon3,
        content4_image: goken_icon4,
        content5_image: goken_icon5,
        content6_image: goken_icon6
    },
    ikf: {
        top_para: "Hirestar.io stepped in with a scalable, AI-powered, and fully automated BGV system built for high-volume NBFC hiring:",
        content1_heading: "AI + Blockchain Engine:",
        content1_para: " Introduced face match, fraud detection, and pre-verified records with blockchain-backed audit trails.",
        content2_heading: "Candidate Self-Verification Portal: ",
        content2_para: "Enabled mobile-first, candidate-led submissions to reduce HR intervention. ",
        content3_heading: "Dedicated Operations Team: ",
        content3_para: "Took over end-to-end coordination and follow-ups, freeing up internal HR bandwidth.",
        content4_heading: "250+ Customizable Checks: ",
        content4_para: "Deployed advanced checks including address, ID, criminal, financial, and social media screening.",
        content5_heading: "Integrated Medical Testing:  ",
        content5_para: "Added pre-employment medical checks into the BGV workflow for field and on-ground staff.",
        content1_image: ikf_icon1,
        content2_image: ikf_icon2,
        content3_image: ikf_icon3,
        content4_image: ikf_icon4,
        content5_image: ikf_icon5,
    },
    monitra: {
        top_para: "Hirestar.io delivered a healthcare-first BGV experience built for speed, scale, and compliance:",
        content1_heading: "Multilingual, Self-Service Verification Portal:",
        content1_para: "Nurses and clinical staff could complete their BGV in Telugu or English — with guided instructions and full mobile accessibility. No manual forms. No HR handholding.",
        content2_heading: "Mobile-First, Zero-Code Platform:",
        content2_para: "Whether in hospitals or remote clinics, staff verified themselves using their phones, instantly uploading documents and completing face verification on the go. ",
        content3_heading: "Healthcare-Specific BGV:",
        content3_para: "Doctors and nurses underwent medical license checks, educational verifications, and professional history reviews — all handled automatically through our AI-powered engine.",
        content4_heading: "Integrated Medical Screenings (200+ tests):",
        content4_para: "From blood sugar and cardiac screenings to drug tests and full-body checkups — Hirestar.io enabled Monitra to handle both BGV and pre-employment health checks on one platform.",
        content5_heading: "Year-Round Medical Camps: ",
        content5_para: " We partnered with Monitra to organize annual wellness camps for employees — reinforcing trust, compliance, and employee health.",
        content1_image: phenom_icon_1,
        content2_image: monitra_icon2,
        content3_image: monitra_icon3,
        content4_image: monitra_icon4,
        content5_image: monitra_icon5,
    },
    incuspaze: {
        top_para: "Hirestar.io partnered with Incuspaze to deliver a fully automated, intelligent, and secure background verification and visitor management solution",
        content1_heading: "Zero-Code Self-Verification Platform: ",
        content1_para: "We deployed a real-time, face-verification module that integrated seamlessly — allowing employees, vendors, and even visitors to complete verification on the go, without manual forms or backend coding.",
        content2_heading: "Real-Time Visitor Identity Validation:",
        content2_para: " Replaced Zoho-based forms with automated face-match + ID verification, enhancing office security and streamlining visitor registration. ",
        content3_heading: "Advanced Company Verification Suite:",
        content3_para: " Delivered automated checks for GST, CIN, DIN, Corporate PAN, Entity Crime Records, and MSA validation — all consolidated into one report.",
        content4_heading: "Fully Automated Standard Verifications:",
        content4_para: " Aadhaar, Driver’s License (DL), and identity verifications were streamlined using AI + Blockchain, reducing turnaround time and human involvement.",
        content5_heading: " Dedicated Support Team:",
        content5_para: " Unlike their previous vendor, Hirestar.io provided SLA-bound support, with rapid response times and complete transparency.",
        content1_image: phenom_icon_1,
        content2_image: incuspaze_icon2,
        content3_image: incuspaze_icon3,
        content4_image: incuspaze_icon4,
        content5_image: incuspaze_icon5,
    },
}

export default function PhenomCaseStudySection3() {
    const { companyName } = useParams();
    const companyData = CaseStudySection4[companyName];

    if (!companyData) {
        return <div>Invalid company</div>;
    }

    const { top_para } = companyData;

    const cards = [];

    for (let i = 1; i <= 6; i++) {
        const headingKey = `content${i}_heading`;
        const paraKey = `content${i}_para`;
        const imageKey = `content${i}_image`;

        if (companyData[headingKey] && companyData[paraKey]) {
            cards.push({
                heading: companyData[headingKey],
                para: companyData[paraKey],
                image: companyData[imageKey] || null,
            });
        }
    }

    return (
        <section className="mx-4  min-h-screen flex items-center justify-center">
            <div className="text-center p-6 max-w-6xl w-full">
                <h3 className="text-[43.26px] font-semibold leading-relaxed text-black mb-6">
                    Client Background
                </h3>

                {/* Top Paragraph */}
                <div className="flex items-center justify-center">
                    <div className="lg:w-[75%] w-full  mx-auto">
                        <p className="text-[23px] font-normal leading-relaxed text-black mb-10 text-center">
                            {top_para}
                        </p>
                    </div>
                </div>


                {/* Card Grid */}
                <div className="grid grid-cols-1 gap-6">
                    {cards.map(({ heading, para, image }, index) => (
                        <div
                            key={index}
                            className="rounded-lg shadow-lg  p-6 flex flex-col md:flex-row items-center md:items-center gap-4"
                        >
                            {/* Image */}
                            {image && (
                                <img
                                    src={image}
                                    alt={`icon-${index + 1}`}
                                    className="w-16 h-16 flex-shrink-0"
                                />
                            )}

                            {/* Text */}
                            <div className="text-center md:text-left">
                                <p className="text-[20px] font-normal">
                                    <b>{heading}</b> {para}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

